module.exports = __webpack_public_path__ + "img/Icon-Medical-Conditions.3d6c1702.svg";